import { motion } from "framer-motion";
import { PropsWithChildren } from "react";

import { shrinkMotionProps } from "@utils/animationUtils";

type Props = PropsWithChildren<{
  className?: string;
}>;

const Collapse = (props: Props) => <motion.div {...shrinkMotionProps} {...props} />;

export default Collapse;
